import { render, staticRenderFns } from "./ConfigEditIcon.vue?vue&type=template&id=b663ef8a"
import script from "./ConfigEditIcon.vue?vue&type=script&lang=js"
export * from "./ConfigEditIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports